import {
  AssetsForStakingQuery$variables,
  AssetsForStakingQuery,
  AssetsForStakingQueryNode,
} from '@bts-web/data-layer/server';
import { gqlNetworkFetch } from '@bts-web/utils-relay';

export const getStakingAssetsData = async (
  params: AssetsForStakingQuery$variables,
) => {
  const response = await gqlNetworkFetch<AssetsForStakingQuery>(
    AssetsForStakingQueryNode.params,
    { ...params },
  );

  return response;
};
